import Vue from 'vue'

Vue.directive('tooltip',{
      bind(el, binding) {
        el.addEventListener("mouseenter", () => {
          const tooltip = document.createElement("div");
          tooltip.textContent = binding.value; // 获取指令值作为提示内容
          tooltip.style.position = "absolute"; // 绝对定位
          tooltip.style.backgroundColor = "#f9f9f9"; // 背景颜色
          tooltip.style.color = "#333"; // 文字颜色
          tooltip.style.padding = "5px 10px"; // 内边距
          tooltip.style.border = "1px solid #ddd"; // 边框
          tooltip.style.borderRadius = "5px"; // 边框圆角
          tooltip.style.zIndex = "1000"; // 层级
          tooltip.style.whiteSpace = "nowrap"; // 不换行
          el.appendChild(tooltip); // 将提示框添加到元素中
        });
        el.addEventListener("mouseleave", () => {
          if (el.querySelector("div")) {
            // 确保元素存在才移除
            el.removeChild(el.querySelector("div")); // 移除提示框元素
          }
        });
      },
})